export const AllSARConstant = {
  SARID: "SAR ID",
  BUUNIT: "Business Unit",
  TITLE: "Title",
  ACTIONNO: "Action Number",
  ACTION: "Action",
  SUPPLIER: "Supplier",
  SUPPLIERNO: "Supplier Number",
  PRIORITY: "Priority",
  BRANCH: "Branch/Plant",
  OWNER: "Owner",
  CREATEDON: "Created On",
  DESCRIPTION: "Description",
  UOM: "UOM",
  MRP: "MRP",
  LINENO: "Line Number",
  MATERIALNO: "Material Number",
  STATUS: "Status",
  LASTMODIFIEDBY: "Last Modified",
  MODIFIEDBY: "Modified By",
  ASSIGNEDTO: "Assigned To",
  UNITUSAGE: "Unit/Estimated Annual Usage",
  TOTALMIN: "Total Minimum",
  TOTALMAX: "Total Maximum",
  ANNUALUSAGE: "Annual Usage Forecast",
  CHANGEINVALUE: "Change In Value",
  TOTALVALUE: "Total Value",
  QACODE: "QA Code",
  THREED: "3D",
  EQUIPMENTCRITICALITY: "Equipment Criticality",
  MANUFACTURE: "Manufacturer",
  MANUFACTURERPARTNUMBER: "Manufacturer Part Number",
  SEGMENT: "Segment",
  MATERIALNUMBER: "Material Number",
  MATERIALGROUPCODE: "Material Group Code",
  SHORTDESCRIPTION: "Short Description",
  ENRICHEDDESCRIPTION: "Enriched Description",
  DATACHANGETYPE: "Data Change Type",
  NEWDATA: "New Data",
  PLANT: "Plant",
  PLANTDF: "Plant DF",
  STORAGELOCATION: "Storage Location",
  STORAGELOCATIONDF: "Storage Location DF",
  RECOMMENDEDMIN: "Recommended Min",
  RECOMMENDEDMAX: "Recommended Max",
  VALUATIONTYPE: "Valuation Type",
  VALUATIONTYPEDF: "Valuation Type DF",
  BIN: "Bin",
  SUBMITTEDBY: "Submitted By",
  SUBMITTEDON: "Submitted On",
  ASSIGNEDGROUP: "Assigned Group",
  APPROVEDBY: "Approved By",
  APPROVEDON: "Approved On",
  CLOSEDBY: "Closed By",
  CLOSEDON: "Closed On"
}
